import { render, staticRenderFns } from "./RenewalGlobal.vue?vue&type=template&id=a2eb370c&scoped=true"
import script from "./RenewalGlobal.vue?vue&type=script&lang=js"
export * from "./RenewalGlobal.vue?vue&type=script&lang=js"
import style0 from "./RenewalGlobal.vue?vue&type=style&index=0&id=a2eb370c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.11.0_ejs@3.1.10_vue-template-compiler@2.6.14_webpack@5.93.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2eb370c",
  null
  
)

export default component.exports